<template>
    <div class="g-steps">
        <PSteps :model="items" :readonly="ehDesenvolvimento">
            <template #item="{item}">
                <div v-on:click="caminho(item.to)" :class="`circulo ${false ? 'circulo-ativo': ''}`" :href="item.url">
                    <i :class="`${item.icon}`"></i>
                </div>

            </template>
        </PSteps>

        <router-view @change="verificaRoute" v-slot="{Component}">
                <component  :is="Component" v-model="teste" :key="$route.name" v-if="!$route.meta.keepAlive"/>
        </router-view>
    </div>
</template>

<script>
import gSteps from './g-steps.js'
export default gSteps
</script>

<style scoped>
:deep(.p-steps .p-steps-item::before){
    border: transparent;
    margin-top: 0px;
    z-index: -1;
}

.g-steps a{
    text-decoration: none;
}

.circulo {
    background: #FCB315;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.circulo:focus{
   background: white;
}

.p-steps-current div.circulo{
    background-color: white;
}

.p-steps-current div.circulo .pi{
    color: #FCB315;
}

:deep(.p-steps-item.p-highlight.p-steps-current::before){
    background-color: #FCB315;
    height: 4px;
    display: flex;
    align-items: center;
}

:deep(.p-steps-item.p-highlight.p-steps-current){
    opacity: 1; /* sem opacidade no elemento que está clicado */
}

:deep(.p-steps-item.p-highlight.p-steps-current .circulo){
    box-shadow: 0px 4px 5px 3px rgba(0, 0, 0, 0.2);
}

:deep(.p-steps-item .circulo-ativo){
    opacity: 1 !important;
}

:deep(.p-steps-item){
    opacity: 0.6; /* opacidade no elemento que não está clicado */
    z-index: 1;
}

:deep(.p-steps .p-steps-item:before){
    height: 4px;
    background-color: #FCB315;
    display: flex;
    align-items: center;
    justify-content: center;
}

:deep(.p-steps .p-steps-item:first-child::before){
    width: 50%;
    margin-left: 50%;
}

:deep(.p-steps .p-steps-item:last-child::before){
    width: 50%;
}

:deep(.p-steps){
    width: v-bind('larguraSteps');
}

.pi:hover{
    color: #FCB315;
}

.pi{
    color: white;
}


@media (min-width:310px) {
:deep(.p-steps) {
    margin: 35px auto 35px;
}
}

@media (min-width:368px) {

}

@media (min-width:600px) {

}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
:deep(.p-steps) {
    margin: 35px auto 50px;
}
}

@media (min-width:1281px) { 
    
}

@media (min-width:1500px) {

}

</style>
